import {
  Component,
  OnInit,
  forwardRef,
  Input,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  template: "",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormBaseElement),
      multi: true,
    },
  ],
})
export class FormBaseElement implements ControlValueAccessor {
  /**
   * Form element name
   */
  @Input("name") name: string;

  /**
   * Form element type [defaults to text ]
   */
  @Input("type") type: string = "text";

  /**
   * Referes to input element in DOM
   */
  @ViewChild("inputElement", { static: true }) inputElement: ElementRef;

  /**
   * Provided value
   */
  @Input("value") _value: any = false;

  /**
   * Field Description - appears right under field
   */
  @Input("description") description: string;

  /**
   * Field Label
   */
  @Input("label") label: string;

  /**
   *
   */
  @Input("itemLabel") itemLabel: string;

  /**
   *
   */
  private onChange: Function = () => {};

  /**
   *
   */
  private onTouched: Function = () => {};

  /**
   *
   */
  private isDisabled: boolean = false;

  /**
   * Constructor
   */
  constructor() {
    //...
  }

  /**
   *
   */
  get value() {
    return this._value ? this._value : "";
  }

  /**
   *
   */
  set value(value) {
    this._value = value;
    this.onChange(value);
    this.onTouched();
  }

  get disabled() {
    return this.isDisabled;
  }

  set disabled(value) {
    this.isDisabled = value;
  }

  /**
   *
   * @param fn
   */
  registerOnChange(fn) {
    this.onChange = fn;
  }

  /**
   *
   * @param value
   */
  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  /**
   *
   * @param fn
   */
  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
  /**
   *
   */
  onKeyUp($event) {
    this.value = this.inputElement.nativeElement.value;
  }
}
